import { getProjectById } from 'apis/project.api';
import { TOAST } from 'constant';
import ReviewForm from 'features/Project/components/RegisterResult/ReviewForm';
import { toast } from 'layout';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { useDownloadRegisterResultFileUpload } from 'utils/hooks/registerResult';

export default function RegisterResultReviewForm({ isLiquidation }) {
  const { t } = useTranslation();
  const { projectId, registerResultId } = useParams();
  // data project
  const { data: _dataProject } = useQuery({
    queryKey: ['dataProject'],
    queryFn: () => getProjectById(projectId),
  });
  const dataProject = useMemo(() => _dataProject?.data ?? {}, [_dataProject]);

  const { mutateAsync: mutateDownloadFile } = useDownloadRegisterResultFileUpload();

  const handleDownloadFile = async (filename, type) => {
    try {
      await mutateDownloadFile({
        registerResultId,
        filename,
        type,
      });
    } catch (error) {
      toast(TOAST.ERROR, t('r09.action.downloadError'));
    }
  };
  return (
    <ReviewForm
      data={dataProject}
      handleDownloadFile={handleDownloadFile}
      registerResultIdUsed={registerResultId}
      isLiquidation={isLiquidation}
    />
  );
}

RegisterResultReviewForm.propTypes = {
  isLiquidation: PropTypes.bool,
};

RegisterResultReviewForm.defaultProps = {
  isLiquidation: false,
};
